export default "__VITE_ASSET__qXHXaTh5__"